import { CheckboxWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-checkbox-widget',
  templateUrl: './checkbox.widget.html'
})
export class MyCheckboxWidgetComponent extends CheckboxWidget {
  public data: any;

  readControl(schema, control) {
    if (schema.widget.id === 'sf-checkbox') {
      this.data = control.value;
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/checkbox/checkbox.widget.ts